import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../sell-fast-page/info-page.css";

const FAQS = [
  {
    category: "Getting Started",
    items: [
      {
        q: "What is AdsOne?",
        a: "AdsOne is Sri Lanka's free vehicle classifieds marketplace. It connects buyers and sellers of cars, vans, lorries, motorbikes, three-wheelers and buses across the island.",
      },
      {
        q: "Is it free to post an ad on AdsOne?",
        a: "Yes — posting a standard listing is completely free. You can choose to boost or feature your ad for greater visibility, but the basic listing will always remain free.",
      },
      {
        q: "Do I need an account to browse ads?",
        a: "No. Anyone can browse and search listings without registering. However, you need a free seller account to post ads, contact sellers or manage your listings.",
      },
    ],
  },
  {
    category: "Posting an Ad",
    items: [
      {
        q: "How do I post a vehicle ad?",
        a: "Click '+ Post Free Ad' in the top navigation, fill in your vehicle details (make, model, year, price, photos, description) and submit. Your ad will go live after a quick review by our team.",
      },
      {
        q: "How many photos can I add to my ad?",
        a: "You can upload up to 5 photos per listing. High-quality photos from multiple angles significantly increase the number of enquiries you receive.",
      },
      {
        q: "How long does it take for my ad to be approved?",
        a: "Our team reviews all ads before they go live. This usually takes a few hours during business hours (Mon–Fri: 9am–6pm, Sat–Sun: 8am–5pm).",
      },
      {
        q: "Can I edit my ad after it has been published?",
        a: "Yes. Go to 'My Ads' in your account, find the listing and click 'Edit'. Updated ads may go through a quick re-review before changes are made visible.",
      },
    ],
  },
  {
    category: "Buying a Vehicle",
    items: [
      {
        q: "How do I contact a seller?",
        a: "Each listing displays the seller's contact number. You can call or WhatsApp the seller directly. Always meet in person before making any payment.",
      },
      {
        q: "Are the sellers on AdsOne verified?",
        a: "Sellers with a blue verified badge have had their identity confirmed by AdsOne. While we encourage verification, always exercise caution and follow our safety tips when dealing with any seller.",
      },
      {
        q: "What should I check before buying a vehicle?",
        a: "Always inspect the vehicle in person, verify the CR book (registration), check chassis and engine numbers against the documents, and consider a pre-purchase inspection by a qualified mechanic.",
      },
    ],
  },
  {
    category: "Boosting & Promotions",
    items: [
      {
        q: "What is a Boosted ad?",
        a: "A Boosted ad is promoted to the top of relevant search results, giving your listing significantly more visibility. Boosted ads can receive up to 10× more views than standard listings.",
      },
      {
        q: "How do I boost my ad?",
        a: "Go to 'My Ads' in your account, find the listing you want to promote and click 'Boost'. Follow the on-screen steps to select your boost package.",
      },
    ],
  },
  {
    category: "Account & Support",
    items: [
      {
        q: "How do I reset my password?",
        a: "Click 'Sign In', then 'Forgot Password'. Enter your registered email address and we will send you a password reset link.",
      },
      {
        q: "How do I report a suspicious ad or user?",
        a: "Use the 'Report' button on any listing or contact our support team at info@adsone.lk. We investigate all reports and take appropriate action.",
      },
      {
        q: "How do I contact AdsOne support?",
        a: "You can reach us by email at info@adsone.lk during business hours (Mon–Fri: 9am–6pm, Sat–Sun: 8am–5pm).",
      },
    ],
  },
];

function FaqItem({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-item__question" onClick={() => setOpen(!open)}>
        <span>{question}</span>
        <FaChevronDown size={14} className={`faq-item__chevron${open ? " faq-item__chevron--open" : ""}`} />
      </button>
      {open && <div className="faq-item__answer">{answer}</div>}
    </div>
  );
}

function FaqPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          {/* Hero */}
          <div className="info-page__hero">
            <p className="info-page__eyebrow">Help Centre</p>
            <h1 className="info-page__title">Frequently Asked Questions</h1>
            <p className="info-page__subtitle">
              Find answers to the most common questions about buying, selling and using AdsOne.
            </p>
          </div>

          {/* FAQ body */}
          <div className="info-page__body">
            {FAQS.map((section, i) => (
              <div key={i}>
                <h5 style={{ fontWeight: 700, color: "#94a3b8", marginBottom: "0.875rem", fontSize: "0.8125rem", textTransform: "uppercase", letterSpacing: "0.07em" }}>
                  {section.category}
                </h5>
                <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginBottom: "0.5rem" }}>
                  {section.items.map((item, j) => (
                    <FaqItem key={j} question={item.q} answer={item.a} />
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="info-page__cta">
            <h3>Still have questions?</h3>
            <p>Our support team is happy to help. Reach us by phone, email or WhatsApp.</p>
            <Link to="/about-us" className="btn px-5 py-2 fw-bold" style={{ borderRadius: "50rem" }}>
              Contact Us
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
}

export default FaqPage;
